const cards = [
  {
    title: '年代大剧《繁花》',
    desc: '王家卫执导，胡歌马伊琍主演，讲述上世纪九十年代上海滩风云变幻中的商战与情义。沪语版全新上线，还原最地道的上海味道。',
    tag: '豆瓣9.2',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%201990s%20Shanghai%20alleyway%20with%20warm%20amber%20streetlights%2C%20vintage%20shop%20signs%20with%20Chinese%20characters%2C%20wet%20cobblestone%20reflecting%20golden%20light%2C%20old%20bicycle%20leaning%20against%20wall%2C%20cinematic%20moody%20atmosphere%20with%20shallow%20depth%20of%20field%2C%20film%20noir%20cityscape%2C%20rich%20textures&width=800&height=560&seq=cards-01&orientation=landscape',
  },
  {
    title: '科幻巨制《流浪地球3》',
    desc: '中国科幻电影巅峰续作，人类命运共同体迎战宇宙危机。4K修复画质加上杜比音效，带来身临其境的太空冒险体验。',
    tag: '票房冠军',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20space%20station%20interior%20with%20massive%20viewport%20showing%20Earth%20and%20stars%2C%20advanced%20technology%20panels%20with%20holographic%20displays%2C%20cool%20blue%20and%20teal%20lighting%20with%20warm%20accent%20glows%2C%20sci-fi%20cinematic%20atmosphere%2C%20grand%20scale%20composition&width=800&height=560&seq=cards-02&orientation=landscape',
  },
  {
    title: '权谋经典《庆余年2》',
    desc: '范闲回归，京都风云再起。张若昀、陈道明等实力派演员联袂出演，权谋与喜剧的完美融合，播放量突破5亿的现象级大剧。',
    tag: '播放破5亿',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20courtyard%20at%20dusk%2C%20golden%20sunlight%20streaming%20through%20traditional%20rooftop%20eaves%2C%20ornate%20red%20lanterns%20and%20wooden%20pillars%2C%20misty%20atmosphere%20with%20soft%20shadows%2C%20historical%20drama%20aesthetic%2C%20elegant%20composition%20with%20warm%20cinematic%20tones&width=800&height=560&seq=cards-03&orientation=landscape',
  },
  {
    title: '暑期动画大片合集',
    desc: '精选国内外高分动画电影，从吉卜力经典到迪士尼最新，从国产原创到日本番剧。全年龄段覆盖，暑期带娃观影首选。',
    tag: '亲子推荐',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20whimsical%20animation%20style%20landscape%20with%20floating%20islands%2C%20pastel%20sky%20with%20soft%20clouds%2C%20magical%20glowing%20particles%2C%20warm%20sunset%20colors%2C%2C%20dreamy%20atmosphere%2C%20family-friendly%20aesthetic%2C%20no%20characters%20visible&width=800&height=560&seq=cards-04&orientation=landscape',
  },
  {
    title: '悬疑烧脑片单',
    desc: '从《隐秘的角落》到《漫长的季节》，国产悬疑剧迎来黄金时代。精编50部高能反转神作，每个细节都暗藏玄机。',
    tag: '高能反转',
    img: 'https://readdy.ai/api/search-image?query=Dark%20moody%20alleyway%20at%20night%20with%20single%20streetlamp%20casting%20long%20shadows%2C%20rain-soaked%20ground%20reflecting%20amber%20light%2C%20mysterious%20atmosphere%20with%20fog%2C%20noir%20cinematic%20composition%2C%20deep%20blues%20and%20warm%20amber%20contrast%2C%20thriller%20mood&width=800&height=560&seq=cards-05&orientation=landscape',
  },
  {
    title: '综艺爆笑名场面',
    desc: '《乘风破浪》《披荆斩棘》《奔跑吧》等王牌综艺高能片段合集，下班解压神器，笑点密集不踩雷。',
    tag: '解压必备',
    img: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20stage%20with%20dynamic%20spotlights%20in%20vibrant%20pink%20and%20golden%20tones%2C%20confetti%20floating%20in%20air%2C%20concert%20atmosphere%20with%20dramatic%20lighting%2C%20entertainment%20show%20energy%2C%20festive%20celebration%20vibe%2C%20no%20people%20visible&width=800&height=560&seq=cards-06&orientation=landscape',
  },
  {
    title: '纪录片频道',
    desc: 'BBC、国家地理、NHK等顶级纪录片资源，涵盖自然、历史、科技、人文。高清画质搭配专业解说，足不出户看世界。',
    tag: '精品内容',
    img: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20landscape%20of%20mountain%20range%20at%20golden%20hour%2C%20dramatic%20clouds%20with%20sun%20rays%20breaking%20through%2C%20pristine%20nature%20scene%2C%20warm%20earthy%20tones%2C%20documentary-style%20cinematography%2C%20epic%20scale%2C%20no%20people%20visible&width=800&height=560&seq=cards-07&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">高分推荐</h2>
          <p className="text-sm text-foreground-500">编辑部严选 · 每一部都值得看</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.slice(0, 6).map((card) => (
            <div
              key={card.title}
              className="rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 group cursor-pointer"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={card.img}
                  alt={`爱豆影视推荐 - ${card.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-bold">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-950 mb-2">{card.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6">
          <div className="rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 group cursor-pointer flex flex-col md:flex-row">
            <div className="relative w-full md:w-[360px] flex-shrink-0 aspect-[4/3] md:aspect-auto overflow-hidden">
              <img
                src={cards[6].img}
                alt={`爱豆影视推荐 - ${cards[6].title}`}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute top-3 left-3">
                <span className="px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-bold">
                  {cards[6].tag}
                </span>
              </div>
            </div>
            <div className="p-5 md:p-6 flex flex-col justify-center">
              <h3 className="text-base font-semibold text-foreground-950 mb-2">{cards[6].title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{cards[6].desc}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}